import Board from "react-trello";
import React, { useState, useEffect, useRef } from "react";
import useFirestoreQuery from "../../hooks/useFirestoreQuery";

import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";

// @COMPATIBILITY
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import ReconVehicleDetailModalArrival from "./ReconVehicleDetailModalArrival";
import ReconVehicleDetailModalQC from "./ReconVehicleDetailModalQC";
import ReconVehicleDetailModalInspection from "./ReconVehicleDetailModalInspection";
import { use } from "react";
import ReconVehicleDetailModalRWCClock from "./ReconVehicleDetailModalRWCClock";

var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

const refreshRateInMs = 5 * 60 * 1000;
const laneBase = require("../../assets/json/lane_base_d1_vic.json");
const externalYardOptions = laneBase?.lanes?.filter(
  (y) => y.activeInRWC === true
);

const PRIMARY_BRANCH_ID = 13; //D1 MELBOURNE (D1 RECON : 13)
const RECON_YARD = "VICRWC"; //
const FREIGHT_IN_YARDS = ["FREIGHTIN", "FreightIn"];

// TESTING
// const PRIMARY_BRANCH_ID = 4; //D1 MELBOURNE (D1 RECON : 13)
// const RECON_YARD = "467Retail"; //

const LANE_MODAL_MAP = [
  {
    laneId: "FreightIn",
    modal: "ARRIVAL",
  },
  {
    laneId: "FREIGHTIN",
    modal: "ARRIVAL",
  },
];

const WholesaleCategory = ["DW", "SYCF"];
const TradeCategory = ["TRADE"];

const nextYardLocation = "VICInspec";

const ReconStockLocationD1VICFreightIn = () => {
  const [reconTrello, setReconTrello] = useState(laneBase);
  const [nextRefresh, setNextRefresh] = useState(refreshRateInMs / 1000);

  const [showDetailModalArrival, setShowDetailModalArrival] = useState(false);
  const [showDetailModalQC, setShowDetailModalQC] = useState(false);
  const [showDetailModalInspection, setShowDetailModalInspection] =
    useState(false);
  const [showDetailModalRWC, setShowDetailModalRWC] = useState(false);

  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedLane, setSelectedLane] = useState(null);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectedCardData, setSelectedCardData] = useState(null);

  const [rwcLane, setRwcLane] = useState([]);
  const [arrivalLane, setArrivalLane] = useState([]);

  const boardRef = useRef(null);
  const searchRef = useRef(null);
  const history = useHistory();

  // const firebase = useFirestore(); // @COMPATIBILITY
  const firestore = firebase.firestore(); // @COMPATIBILITY

  const { data, status, error } = useFirestoreQuery(
    firestore
      .collection("vehicle-health-vic")
      .where("CurrentStatus", "==", "IN-STOCK")
      .where("BranchId", "==", PRIMARY_BRANCH_ID)
      .where("VEHYard", "in", FREIGHT_IN_YARDS)
  );

  const handleShowModal = (cardId, metadata, laneId) => {
    // console.log(metadata);
    // window.open(`/vin/${metadata?.veh?.VEHVIN}`, "_blank");
    console.log("laneId", laneId);
    setSelectedCardId(cardId);
    setSelectedCardData(metadata);
    setSelectedCard(metadata?.veh);
    setShowDetailModalArrival(true);
    // const modal = LANE_MODAL_MAP.find((item) => item.laneId === laneId);
    // switch (modal?.modal) {
    //   case "ARRIVAL":

    //     break;

    //   case "QC":
    //     setShowDetailModalQC(true);
    //     break;

    //   case "INSPECTION":
    //     setShowDetailModalInspection(true);
    //     break;

    //   case "RWC":
    //     setShowDetailModalRWC(true);
    //     break;

    //   default:
    //     // setShowDetailModalArrival(true);
    //     break;
    // }
  };

  const handleClose = (modalName) => {
    if (modalName === "ARRIVAL") {
      setShowDetailModalArrival(false);
    } else {
      setShowDetailModalInspection(false);
    }
  };

  const boardScroll = (scrollOffset) => {
    const br = document.getElementsByClassName("react-trello-board")[0];
    br.scrollLeft += scrollOffset;
  };

  const boardScrollMax = (direction) => {
    const br = document.getElementsByClassName("react-trello-board")[0];
    if (direction > 0) {
      // Right
      br.scrollLeft = br.scrollWidth;
    } else {
      // Left
      br.scrollLeft = 0;
    }
  };

  //   Transform to trello board
  useEffect(() => {
    if (data) {
      //   clear all cards
      let tmpLaneArray = laneBase.lanes.map((l) => {
        l.cards = [];
        if (l.category !== "0") {
          l.style = {
            backgroundColor: laneBase?.categoryColours[l.category].laneBgColour,
            color: laneBase?.categoryColours[l.category].laneFontColour,
          };
        }
        return l;
      });

      // Filter active only
      tmpLaneArray = tmpLaneArray.filter((l) => l.active);

      // Sort by category
      tmpLaneArray = tmpLaneArray.sort((a, b) => a.categoryId - b.categoryId);

      // Get list of yards
      for (var i = 0; i < data.length; i++) {
        const veh = data[i];

        // console.log(veh);
        const daysInYard = Math.ceil(
          (dayjs().unix() - dayjs.unix(veh.Yard_Change_Date_EPOC) / 1000) /
            60 /
            60 /
            24
        );

        // Show branch if in Retail branches
        let currentBranch = "";
        // if (veh.Branch !== "AMW - BUYING/RECONDITIONING") {
        //   currentBranch = veh.Branch.replace("D1 ", "");
        // }

        let tmpCard = {
          id: `${veh.VEHStockNumber}`,
          title: `${veh.VEHMake} ${veh.VEHmodel} ${veh.Variant}`,
          description: `${veh.VEHStockNumber} ${currentBranch} ${
            veh.Yard_Change_Date_EPOC
              ? ": " +
                dayjs.unix(veh.Yard_Change_Date_EPOC).format("DD/MM") +
                " - " +
                daysInYard
              : ""
          }`,
          label: `${veh.Age}`,
          draggable: false,
          metadata: {
            veh,
          },
          // Add tags when yard logs are added to show progress
          tags: [],
        };

        // Get active yards
        const activeYards = laneBase.lanes.filter((l) => l.active);

        // Order yard logs by date changed
        // Order by date
        veh.yardLogs = veh.yardLogs?.sort((a, b) => {
          return a.Yard_Change_Date_EPOC - b.Yard_Change_Date_EPOC;
        });

        for (var j = 0; j < veh?.yardLogs?.length; j++) {
          const log = veh.yardLogs[j];
          let logNext = null;
          if (j < veh?.yardLogs?.length - 1) {
            logNext = veh.yardLogs[j + 1];
          }

          const isReconYard = activeYards.find((y) => y.id === log.VEHYard);

          if (isReconYard) {
            // Don't add tag for yard log for the current yard
            // Add tag if same yard as current yard but different time stamp (went into yard previously)
            if (
              (log.VEHYard?.toLowerCase() !== veh.VEHYard?.toLowerCase() ||
                log.VEHYard?.length === 0 ||
                (log.VEHYard?.toLowerCase() === veh.VEHYard?.toLowerCase() &&
                  log.Yard_Change_Date_EPOC !== veh.Yard_Change_Date_EPOC)) &&
              log.VEHYard !== "AMWRecon"
            ) {
              let daysBetweenYards = "";
              if (logNext !== null) {
                daysBetweenYards = Math.ceil(
                  (logNext.Yard_Change_Date_EPOC - log.Yard_Change_Date_EPOC) /
                    60 /
                    60 /
                    24
                );
              }

              const title = `${log.VEHYard} (${daysBetweenYards})`;

              let tmpTag = {
                bgcolor:
                  laneBase.categoryColours[isReconYard.category].tagBgColour,
                color:
                  laneBase.categoryColours[isReconYard.category].tagFontColour,
                title: title,
              };

              tmpCard.tags.push(tmpTag);
            }
          }
        }

        const laneIndex = tmpLaneArray.findIndex(
          (l) => l.id === veh.VEHYard?.replace(/^\s+|\s+$/gm, "")
        );

        tmpLaneArray[laneIndex]?.cards.push(tmpCard);
      }

      // Set lane labels with count
      tmpLaneArray = tmpLaneArray.map((l) => {
        return { ...l, label: `${l.cards.length}` };
      });
      setReconTrello({ lanes: tmpLaneArray });
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (reconTrello?.lanes?.length > 0) {
      console.log("reconTrello", reconTrello);
      const tmpArrivalLaneFreightInM = reconTrello?.lanes?.find((l) =>
        l.id?.includes("FreightIn")
      );
      const tmpArrivalLaneFreightInArrival = reconTrello?.lanes?.find((l) =>
        l.id?.includes("FREIGHTIN")
      );
      const tmpArrivalLaneFreightIn = {
        ...tmpArrivalLaneFreightInM,
        cards: [
          ...(tmpArrivalLaneFreightInM?.cards || []),
          ...(tmpArrivalLaneFreightInArrival?.cards || []),
        ],
      };
      console.log("tmpArrivalLane", tmpArrivalLaneFreightIn);
      setArrivalLane(tmpArrivalLaneFreightIn);
    }
  }, [reconTrello]);

  // // Data refresh
  // useEffect(() => {
  //   let interval;

  //   const updateCounter = () => {
  //     setNextRefresh((currentValue) => currentValue - 1);
  //   };

  //   interval = setInterval(() => {
  //     console.log("Refreshing");
  //     updateCounter();
  //   }, refreshRateInMs);

  //   return () => {
  //     // Clear the interval when component is unmounted
  //     clearInterval(interval);
  //   };
  // }, []);

  return (
    <>
      <Toaster />

      {/* <Button onClick={() => boardScroll(200)}>Scroll</Button> */}

      {/* Filter search for last 6 digits of VIN */}
      <Row>
        <Col>
          <Form.Group className="mb-3">
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="Search by VIN"
                type="text"
                ref={searchRef}
                className="mb-3"
                onChange={(e) => {
                  const search = e.target.value;
                  const filteredCards = laneBase.lanes.map((lane) => {
                    return {
                      ...lane,
                      cards: lane.cards.filter((card) =>
                        card.metadata?.veh?.VEHVIN.includes(
                          search.toLowerCase()
                        )
                      ),
                    };
                  });
                  setReconTrello({ lanes: filteredCards });
                }}
              />
              <Button
                size="sm"
                className="mb-3"
                variant="outline-secondary"
                id="button-addon2"
                onClick={() => {
                  setReconTrello(laneBase);
                  searchRef.current.value = "";
                  searchRef.current.focus();
                }}
              >
                x
              </Button>
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* <pre>{JSON.stringify(rwcLane, null, 2)}</pre> */}
          <h6>Arrival Queue</h6>
          <h6>Current branch id: {PRIMARY_BRANCH_ID}</h6>
          <h6>Cars: {arrivalLane?.cards?.length}</h6>
        </Col>
      </Row>
      <Row>
        <Col>
          {arrivalLane?.cards?.map((card, index) => {
            return (
              <Card key={index} className="mb-2">
                <Card.Body>
                  <Card.Title>
                    {card.title}
                    {/* If card?.metadata?.veh?.VEHCategory is Wholesale show a red circle  */}
                    {WholesaleCategory.includes(
                      card?.metadata?.veh?.VEHCategory
                    ) && (
                      <span
                        className="badge bg-danger ms-2 ml-2"
                        style={{
                          borderRadius: "50%",
                          fontSize: "1.2rem",
                          color: "white",
                        }}
                      >
                        W
                      </span>
                    )}
                    {/* If card?.metadata?.veh?.VEHCategory is Trade show a blue circle */}
                    {TradeCategory.includes(
                      card?.metadata?.veh?.VEHCategory
                    ) && (
                      <span
                        className="badge bg-danger ms-2 ml-2"
                        style={{
                          borderRadius: "50%",
                          fontSize: "1.2rem",
                          color: "white",
                        }}
                      >
                        T
                      </span>
                    )}
                  </Card.Title>
                  <Card.Text>{card.description}</Card.Text>
                  <Card.Text>{card?.metadata?.veh?.VEHVIN}</Card.Text>

                  <ButtonGroup className="mb-2">
                    <Button
                      variant="outline-primary"
                      onClick={() =>
                        handleShowModal(card.id, card.metadata, "FREIGHTIN")
                      }
                    >
                      Details
                    </Button>
                  </ButtonGroup>
                </Card.Body>
              </Card>
            );
          })}
        </Col>
      </Row>

      <ReconVehicleDetailModalArrival
        show={showDetailModalArrival}
        data={selectedCardData}
        handleClose={() => handleClose("ARRIVAL")}
        createNew={false}
        stateFilter={null}
        buyingFilterUserRoles={null}
      />
    </>
  );
};

export default ReconStockLocationD1VICFreightIn;
